<nz-select
  nzShowSearch
  nzServerSearch
  [nzAllowClear]="true"
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event)"
  (nzOpenChange)="search('')"
  [nzCustomTemplate]="displayTpl"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzDropdownRender]="loadingTpl"
  [nzBorderless]="borderless"
  nzDropdownClassName="dropdownSelect"
  class="width-100"
>
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>
  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="o[valueField]" [nzLabel]="o.referenceNo" nzCustomContent>
      <b>{{ o.referenceNo }}</b>
      <br />
      <small>{{ o.docCode }}</small>
    </nz-option>
  </ng-container>
</nz-select>
<ng-template #loadingTpl>
  <div *ngIf="searching">
    <nz-spin></nz-spin>
    Loading
  </div>
</ng-template>
